"use client";
import { IBlocks, IThroneUser } from "@/types";
import React from "react";
import CardSetting from "@/components/admin/settings/CardSetting";
import { Input } from "@/components/ui/input";
interface Props {
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
}

export default function ThroneWishlistOptions({
    block,
    blockUpdate,
    update,
}: Props) {
    const [username, setUsername] = React.useState(block.options.username);
    const [oldBlock, setOldBlock] = React.useState(block);
    return (
        <CardSetting noBorder>
            <div className="border-3 flex w-full flex-col gap-3 border-white">
                <Input
                    label="Throne Username"
                    variant="card"
                    className="w-full"
                    placeholder="andilippi"
                    required
                    value={username}
                    onChange={(e) => {
                        setUsername(e.target.value);
                        blockUpdate({
                            ...block,
                            options: {
                                ...block.options,
                                username: e.target.value,
                                user_id: null,
                            },
                        });
                    }}
                    onBlur={async (e) => {
                        if (oldBlock.options.username !== e.target.value) {
                            const user = await ThroneWishlistUserCheck(
                                e.target.value
                            );
                            update({
                                ...block,
                                options: {
                                    ...block.options,
                                    username: e.target.value,
                                    user_id: user.user?.id,
                                },
                            });
                            setOldBlock({
                                ...oldBlock,
                                options: {
                                    ...block.options,
                                    username: e.target.value,
                                    user_id: user.user?.id,
                                },
                            });
                        } else if (!oldBlock.options.user_id) {
                            const user = await ThroneWishlistUserCheck(
                                e.target.value
                            );
                            update({
                                ...block,
                                options: {
                                    ...block.options,
                                    username: e.target.value,
                                    user_id: user.user?.id,
                                },
                            });
                            setOldBlock({
                                ...oldBlock,
                                options: {
                                    ...block.options,
                                    username: e.target.value,
                                    user_id: user.user?.id,
                                },
                            });
                        }
                    }}
                />
            </div>
        </CardSetting>
    );
}

async function ThroneWishlistUserCheck(username: string): Promise<{
    user: IThroneUser | null;
}> {
    const usernameResponse: IThroneUser = await fetch(
        "https://us-central1-onlywish-9d17b.cloudfunctions.net/api-creator/v1/profile/username/" +
            username,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }
    ).then(async (response) => await response.json());
    if (!usernameResponse?.id) {
        return {
            user: null,
        };
    }
    return {
        user: usernameResponse,
    };
}
